import { RG_TYPE } from '../../types/rg-type.js';

const DefaultParapet = {
    type: RG_TYPE.Parapet,
    size: [6, 3, 0.1],
    anchor: [0.5, 0, 0.5],
    name: 'parapet',
    color: '#ECECEC',
    children: []
};

export { DefaultParapet };
//# sourceMappingURL=default-parapet.js.map
